// DEV-02 配對完取名（SPEC #vms-web-327，Eddy 2026-10-08 選單；app/vms#2）：預填「家戶名（組織家戶在節點下時用節點名）+ 機種友善名」。
// 機種友善名先依設備 ID 的類型碼（AID 前 3 碼，同 platform cmd/app-api deviceCategory）給語系化的種類名；名稱上限 32 字（平台 422 INVALID_NAME）。

export const DEVICE_NAME_MAX = 32;

export type DeviceKind = 'camera' | 'doorbell' | 'nvr' | 'station' | 'sensor' | 'light' | 'lock' | 'plug' | 'frame' | 'other';

/** AID 類型碼 → 種類（照 platform deviceCategory；通道一律 camera）。 */
export function aidKind(aid: string): DeviceKind {
  if (/:ch\d+$/i.test(aid)) return 'camera';
  const tc = (aid.match(/^([A-Za-z]{3})-/)?.[1] ?? '').toUpperCase();
  switch (tc) {
    case 'CAM':
    case 'CFL':
    case 'CSN':
      return 'camera';
    case 'CVD':
    case 'CDB':
    case 'CAD':
    case 'CIN':
      return 'doorbell';
    case 'CNV':
    case 'CDV':
      return 'nvr';
    case 'KST':
      return 'station';
    case 'DLK':
    case 'DLC':
      return 'lock';
    case 'PON':
    case 'PDM':
      return 'plug';
    case 'MPF':
    case 'MDS':
      return 'frame';
  }
  if (tc.startsWith('L')) return 'light';
  if (tc.startsWith('S') && tc !== 'SFT') return 'sensor';
  return 'other';
}

/** 預填名稱的前半：組織家戶在節點下（標籤「北區 › 信義據點 › 301」）用最近的節點名，否則用家戶名。 */
export function nameBase(homeName: string, targetLabel?: string): string {
  const parts = (targetLabel ?? '').split(' › ').map((s) => s.trim()).filter(Boolean);
  if (parts.length > 1) return parts[parts.length - 2];
  return homeName.trim();
}

/** 預填名稱：「<前半> <種類>」，超過 32 字從前半截。 */
export function defaultDeviceName(base: string, kindName: string): string {
  const k = kindName.trim();
  let b = base.trim();
  const room = DEVICE_NAME_MAX - [...k].length - 1;
  if ([...b].length > room) b = [...b].slice(0, Math.max(room, 0)).join('').trim();
  return (b ? `${b} ${k}` : k).slice(0, DEVICE_NAME_MAX);
}
